import React, { useEffect, useState } from "react";
import { getListSeasons } from "../../api";
import { Season } from "../../types"; 
import { Button } from "../common/Button";
import { LS_CURRENT_SEASON } from "../../config/api";

interface ModalSelectSeasonProps {
  currentSeason: Season;
  onSelect: (season: Season) => void;
  onClose: () => void;
}
export const ModalSelectSeason: React.FC<ModalSelectSeasonProps> = ({currentSeason, onSelect, onClose}) => {
    const [seasons, setSeasons] = useState<Season[]>([]);
    
    useEffect(() => {
      // Lista stagioni
      const loadData = async () => {
        const data = await getListSeasons();
        setSeasons(data);
      }
      loadData();
    }, []);

    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/50">
        <div className="bg-white p-4 rounded w-80">
          <h2 className="text-lg font-bold mb-2">Seleziona stagione</h2>
          <ul className="space-y-2">
            {seasons.map((s) => (
              <li key={s.id}>
                <Button
                  className="w-full border border-gray-300"
                  variant={s.id === currentSeason.id ? "secondary" : "ghost"}
                  onClick={() => {
                    localStorage.setItem(LS_CURRENT_SEASON, JSON.stringify(s));
                    onSelect(s);
                  }}
                >
                  {s.name} {s.is_active ? "(Attiva)" : ""}
                </Button>
              </li>
            ))}
          </ul>
          <Button
            className="mt-4 w-full"
            variant="destructive"
            onClick={() => onClose()}
          >
            Chiudi
          </Button>
        </div>
      </div>
    )
}
/**

 */